import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class MenuIconService {
  private currentIcon = signal<string>('Folder');

  /** Nombre, ya traducido, de la opcion del menu que se esta viendo; vacio si ninguna corresponde. */
  private readonly currentOptionName = signal<string>('');

  /**
   * Clave i18n del `ai_context` de la opcion que se esta viendo (su `config.ai_context` en el menu);
   * vacia si la opcion no lo declara o si ninguna corresponde.
   */
  private readonly currentOptionAiContext = signal<string>('');

  getIcon() {
    return this.currentIcon;
  }

  setIcon(icon: string) {
    this.currentIcon.set(icon);
  }

  getOptionName() {
    return this.currentOptionName.asReadonly();
  }

  setOptionName(nombre: string) {
    this.currentOptionName.set(nombre);
  }

  getOptionAiContext() {
    return this.currentOptionAiContext.asReadonly();
  }

  setOptionAiContext(clave: string) {
    this.currentOptionAiContext.set(clave);
  }
}
